export const eur = (n) =>
  new Intl.NumberFormat("en-IE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

// Indicative local-currency conversion shown alongside EUR (closest current rate).
const RATES = { sv: { rate: 11.3, code: "SEK", locale: "sv-SE", suffix: " kr" } };
export function localMoney(amountEur, lang) {
  const r = RATES[lang];
  if (!r || !amountEur) return null;
  const rounded = Math.round((amountEur * r.rate) / 100) * 100;
  return `≈ ${new Intl.NumberFormat(r.locale).format(rounded)}${r.suffix}`;
}

export const STATUS_LABEL = {
  itinerary_sent: "Itinerary Sent",
  requested: "Booking Requested",
  pending_invoice: "Booking Requested",
  availability_confirmed: "Availability Confirmed",
  waiting_for_payment: "Waiting for Payment",
  deposit_paid: "Deposit Paid",
  confirmed: "Confirmed",
  enriched: "Details Finalised",
  completed: "Completed",
  cancelled: "Cancelled",
};
